"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiGetFileUrlsRequestActionEnum = void 0;
exports.instanceOfApiGetFileUrlsRequest = instanceOfApiGetFileUrlsRequest;
exports.ApiGetFileUrlsRequestFromJSON = ApiGetFileUrlsRequestFromJSON;
exports.ApiGetFileUrlsRequestFromJSONTyped = ApiGetFileUrlsRequestFromJSONTyped;
exports.ApiGetFileUrlsRequestToJSON = ApiGetFileUrlsRequestToJSON;
exports.ApiGetFileUrlsRequestToJSONTyped = ApiGetFileUrlsRequestToJSONTyped;
/**
 * @export
 */
exports.ApiGetFileUrlsRequestActionEnum = {
    get: 'get',
    put: 'put'
};
/**
 * Check if a given object implements the ApiGetFileUrlsRequest interface.
 */
function instanceOfApiGetFileUrlsRequest(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    if (!('keys' in value) || value['keys'] === undefined)
        return false;
    return true;
}
function ApiGetFileUrlsRequestFromJSON(json) {
    return ApiGetFileUrlsRequestFromJSONTyped(json, false);
}
function ApiGetFileUrlsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'action': json['action'],
        'keys': json['keys'],
    };
}
function ApiGetFileUrlsRequestToJSON(json) {
    return ApiGetFileUrlsRequestToJSONTyped(json, false);
}
function ApiGetFileUrlsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'action': value['action'],
        'keys': value['keys'],
    };
}
